import { useState, useEffect, useContext, useMemo, useCallback } from "react";
import { useMsal } from "@azure/msal-react";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { ShotClockService } from "../../services/ShotClockService";
import { AlertContext } from "../../components/Dashboard/Dashboard";

export default function useShotClockReceiver() {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [connection, setConnection] = useState(null);
  const [lockedLoadsArray, setLockedLoadsArray] = useState([]);
  const [updatedLoad, setUpdatedLoad] = useState({});

  const lockedLoads = useMemo(() => lockedLoadsArray, [lockedLoadsArray]);

  const getAllLocks = useCallback(() => {
    setTimeout(() => {
      ShotClockService.GetLockedLoads(instance).then(res => {
        setLockedLoadsArray(res);
      }).catch(error => {
        console.error(error);
        warning(error);
      });
    }, 1);
  }, []);

  useEffect(() => {
    getAllLocks();

    setInterval(() => {
      getAllLocks();
    }, 60000);

    const newConnection = new HubConnectionBuilder()
      .withUrl("/LockNotifications")
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();

    setConnection(newConnection);
  }, []);

  useEffect(() => {
    async function start() {
      try {
        await connection.start();
        connection.on("MovementLocked", update => {
          setUpdatedLoad(update);
        });
        connection.on("MovementUnLocked", update => {
          setUpdatedLoad(update);
        });
      } catch (err) {
        console.error(err);
      }
    }

    if (connection) {
      start();
    }
  }, [connection]);

  useEffect(() => {
    if (updatedLoad.id) {
      let updatedLoads = [...lockedLoadsArray];
      const index = updatedLoads.findIndex(load => load.id === updatedLoad.id);

      if (index >= 0 && updatedLoad.lockedUserId) {
        updatedLoads.splice(index, 1, updatedLoad);
      } else if (index >= 0 && !updatedLoad.lockedUserId) {
        updatedLoads.splice(index, 1);
      } else if (index < 0 && updatedLoad.lockedUserId) {
        updatedLoads.push(updatedLoad);
      }

      setLockedLoadsArray(updatedLoads);
    }
  }, [updatedLoad]);

  return {
    lockedLoads
  };
}